
import card from '~/mixins/card'
export default {
    mixins: [card],
}
